import { createReducer } from './util';
import { CHANGE_MUSIC_PLAY_ACTION } from '../actions/music-player';

export const musicPlayerInitialState = {
  musicPlayer: {
    play: false,
  }
};

export const musicPlayer = createReducer(
  musicPlayerInitialState.musicPlayer,
  {
    [CHANGE_MUSIC_PLAY_ACTION]: (_, { play }) => ({ play }),
  }
);



// WEBPACK FOOTER //
// ./src/reducers/music-player.js